// 创建一个简单的事件总线
class EventBus {
  constructor() {
    this.events = {}
  }

  // 监听事件
  $on(event, callback) {
    if (!this.events[event]) {
      this.events[event] = []
    }
    this.events[event].push(callback)
  }

  // 触发事件
  $emit(event, ...args) {
    if (this.events[event]) {
      this.events[event].forEach(callback => {
        callback(...args)
      })
    }
  }

  // 移除事件监听
  $off(event, callback) {
    if (this.events[event]) {
      if (callback) {
        const index = this.events[event].indexOf(callback)
        if (index > -1) {
          this.events[event].splice(index, 1)
        }
      } else {
        delete this.events[event]
      }
    }
  }
}

// 创建单例实例
const eventBus = new EventBus()

export default eventBus
